import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream px-6">
      <div className="max-w-md w-full text-center bg-white rounded-3xl border border-brand-border/60 p-10 shadow-[0_8px_30px_rgba(74,93,82,0.10)]">
        <XCircle className="w-14 h-14 text-brand-slate mx-auto mb-4" />
        <h1 className="font-heading text-2xl mb-2">Payment cancelled</h1>
        <p className="text-brand-slate mb-6">No charge was made. You can upgrade anytime.</p>
        <Button data-testid="cancel-back-btn" onClick={() => navigate("/dashboard")} className="rounded-full bg-brand-primary hover:bg-brand-primaryHover text-white">Back to Studio</Button>
      </div>
    </div>
  );
}
